export default __webpack_public_path__ + "static/media/mode-523.0fff769e.svg";